//@flow
import * as React from "react";
import { css } from "emotion";
import styled, { keyframes } from "react-emotion";
import { theme, mqMin } from "../../styles/theme";
import { Fade, Zoom } from "react-reveal";
import PageProgress from "../PageProgress";
import ScrollNotifier from "../ScrollNotifier";

const screen = styles =>
  css`
    display: flex;
    ${styles};
  `;

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1
    transform: translateY(0);

  }
`;

const Text = styled.div`
  z-index: 3;
  animation: ${fadeUp} 750ms ease-in forwards;
  animation-delay: 150ms;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  opacity: 0;
  transform: translateY(100%);

  ${mqMin(theme.desktop)} {
    width: ${theme.maxWidth2};
  }
`;

const Heading = styled.div`
  font-family: ${theme.heading.fontFamily};
  font-weight: ${theme.heading.bold};
  font-size: ${theme.h1};
  line-height: ${theme.lineHeight2};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.super};
  }
`;

const Subtext = styled.div`
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.normal};
  font-size: ${theme.h4};
  margin-top: ${theme.space1};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h3};
  }
`;

const Hero = ({ text, subtext, styles = "" }) => (
  <PageProgress styles={screen(styles)}>
    {({ progress }) => (
      <div>
        <ScrollNotifier onEnter="INTRO_ENTER" onLeave="INTRO_LEAVE" />
        <Text>
          {text && <Heading dangerouslySetInnerHTML={{ __html: text }} />}
          {subtext && <Subtext dangerouslySetInnerHTML={{ __html: subtext }} />}
        </Text>
      </div>
    )}
  </PageProgress>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/index.js